let app = {};
import alasql from 'alasql';

app.run = function (temp) {
    if (temp.length == 0) {
        toastr.error("Minimum 1 Item Required");
        return false;
    }
    let data = [];
    temp.forEach(val => {
        data.push(val);
    });
    var res = alasql('SELECT * from ? where quantity < 1 ', [data]);
    if (res.length > 0) {
        toastr.error("Quantity Should Not Less Than 1!");
        return false;
    }

    var res = alasql('SELECT * from ? where ( name is null or name = "" )', [data]);
    if (res.length > 0) {
        toastr.error("Item Name Should Not Empty!");
        return false;
    }
    return true;

}

export default app;
